import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SiteHeader } from "@/components/site/SiteHeader";
import { Footer } from "@/components/landing/Footer";

const FALLBACK_COMPANY = {
    name: "G21 Projekt GmbH",
    phone: "+49 6134 28 63 266",
    email: "buero@neubau-kaufen-wiesbaden.de",
    address: "Gaugasse 19, 65203 Wiesbaden",
    project_address: "Gaugasse 21, 65203 Wiesbaden",
};

/**
 * PageShell – shared layout for the redesigned multi-page site.
 * Wraps every public route with the glass SiteHeader + unified Footer.
 * Provides the `company` context (fetched once from /api/company) to children.
 */
export const PageShell = ({ children, testId = "page-shell" }) => {
    const [company, setCompany] = useState(FALLBACK_COMPANY);

    useEffect(() => {
        api.get("/company")
            .then((r) => setCompany({ ...FALLBACK_COMPANY, ...(r.data || {}) }))
            .catch(() => setCompany(FALLBACK_COMPANY));
    }, []);

    return (
        <main className="bg-linen text-sage-700 min-h-screen pt-16 sm:pt-20" data-testid={testId}>
            <SiteHeader />
            {typeof children === "function" ? children(company) : children}
            <Footer company={company} />
        </main>
    );
};
